export const allocation = {
  maxLeads: 30,
};
